
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 104 104","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"52","cy":"52","r":"52"}}),_c('circle',{attrs:{"cx":"52","cy":"52","r":"50","fill":"#fff"}}),_c('path',{attrs:{"d":"M31.222 27a2.5 2.5 0 00-2.335 1.61l-3.953 10.37a5 5 0 00-.035 3.463 6.878 6.878 0 0013.35-2.318 6.875 6.875 0 1013.75 0 6.875 6.875 0 1013.75 0 6.877 6.877 0 0013.35 2.318 4.985 4.985 0 00-.037-3.463l-3.95-10.37A2.5 2.5 0 0072.777 27H31.222zM50.643 54.5h-15c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25v-12.5c0-.69-.56-1.25-1.25-1.25zM56.893 77V55.75a1.25 1.25 0 011.25-1.25h10a1.25 1.25 0 011.25 1.25V77","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M74.393 46.77V74.5a2.5 2.5 0 01-2.5 2.5h-40a2.5 2.5 0 01-2.5-2.5V46.71","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    